import { ButtonHTMLAttributes } from "react";

interface ButtonLoginProps extends ButtonHTMLAttributes<HTMLButtonElement> {

}

export function ButtonLogin(props: ButtonLoginProps) {
  return (
    <button
      {...props}
      className="group relative flex w-full justify-center rounded-sm border border-transparent bg-[#349946] py-2 px-4 text-sm font-medium text-white hover:bg-[#3aa24d] focus:outline-none"
    />
  );
}